<template>
  <div class="page-column">
    <Header></Header>
    <AgencyContent />
    <Footer />
    <BackTop />
  </div>
</template>

<script>
import Header from './Header'
import AgencyContent from './components/AgencyContent'
import Footer from './Footer'
import BackTop from '@comm/components/public/BackTop'
export default {
  components: {
    Header,
    AgencyContent,
    Footer,
    BackTop,
  },
}
</script>

<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/layout/Agency.vue